import React from 'react'

import SignIn from './signIn'
import config from '../../../../common/config'
import { handleSubmit, autoSignIn } from './signInHelper'

const recaptchaKey = config.sso.RECAPTCHA_KEY

export default class SignInModalContainer extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showReCAPTCHA: false,
      show2FA: false,
      showLoading: false,
      showUsernameMissing: false,
      showPasswordMissing: false,
      showServerError: false,
      data: {
        username: null,
        password: null,
        to: props.openModalData.currentSite,
        authentication_code: null
      },
      passwordErrorMsg: null,
      twoFAErrorMsg: null
    }

    this.onInputChange = this.onInputChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onReCAPTCHAChange = this.onReCAPTCHAChange.bind(this)
  }

  componentDidMount () {
    const { closeModal } = this.props
    const {
      onSignInSuccess,
      currentSite
    } = this.props.openModalData
    this.setState({
      showLoading: true
    })
    const payload = {
      to: currentSite
    }
    autoSignIn(payload, {
      handleAutoSignInSuccess: token => {
        onSignInSuccess(token).then(() => {
          this.setState({
            showLoading: false
          })
          closeModal()
        })
      },
      handleAutoSignInError: () => {
        this.setState({
          showLoading: false
        })
      }
    })
  }

  onReCAPTCHAChange (recaptchaResponse) {
    this.setState({
      data: {
        ...this.state.data,
        recaptcha_version: '2',
        recaptcha_site_key: recaptchaKey,
        recaptcha_response: recaptchaResponse
      }
    })
  }

  onInputChange (name) {
    return (event) => {
      this.setState({
        data: {
          ...this.state.data,
          [name]: event.target.value
        }
      })
    }
  }

  onSubmit (event) {
    const { closeModal } = this.props
    const { data } = this.state
    const { onSignInSuccess } = this.props.openModalData
    event.preventDefault()

    // reset form state on submit
    this.setState({
      showLoading: true,
      showReCAPTCHA: false,
      show2FA: false,
      showUsernameMissing: false,
      showPasswordMissing: false,
      showServerError: false,
      data: {
        ...this.state.data,
        recaptcha_version: null,
        recaptcha_site_key: null,
        recaptcha_response: null,
        authentication_code: null
      },
      passwordErrorMsg: null,
      twoFAErrorMsg: null
    })

    if (!data.username) {
      this.setState({
        showLoading: false,
        showUsernameMissing: true
      })
      return
    }

    if (!data.password) {
      this.setState({
        showLoading: false,
        showPasswordMissing: true
      })
      return
    }

    handleSubmit(data, {
      handleSignInSuccess: token => {
        onSignInSuccess(token).then(() => {
          this.setState({
            showLoading: false
          })
          closeModal()
        })
      },
      handleSignInError: () => {
        this.setState({
          showLoading: false,
          showServerError: true
        })
      },
      handlePassword: data => {
        this.setState({
          showLoading: false,
          passwordErrorMsg: data.error_message || 'Whoops! Something went wrong.'
        })
      },
      handleCaptcha: data => {
        if (data.error_message) {
          this.setState({
            showLoading: false,
            showReCAPTCHA: true,
            passwordErrorMsg: data.error_message || 'Whoops! Something went wrong.'
          })
        } else {
          this.setState({
            showLoading: false,
            showReCAPTCHA: true
          })
        }
      },
      handle2FA: data => {
        if (data.error_message) {
          this.setState({
            showLoading: false,
            show2FA: true,
            twoFAErrorMsg: data.error_message
          })
        } else {
          this.setState({
            showLoading: false,
            show2FA: true
          })
        }
      },
      handleSignInVerification: data => {
        if (data.redirect) {
          window.location = data.redirect
        }
        this.setState({
          showLoading: false
        })
      },
      handlePasswordReset: data => {
        if (data.redirect) {
          window.location = data.redirect
        }
        this.setState({
          showLoading: false
        })
      },
      handleEmailConfirmation: data => {
        if (data.redirect) {
          window.location = data.redirect
        }
        this.setState({
          showLoading: false
        })
      }
    })
  }

  render () {
    const {
      showReCAPTCHA,
      show2FA,
      showUsernameMissing,
      showPasswordMissing,
      showServerError,
      showLoading,
      data,
      passwordErrorMsg,
      twoFAErrorMsg
    } = this.state

    return (<SignIn
      showReCAPTCHA={showReCAPTCHA}
      show2FA={show2FA}
      showUsernameMissing={showUsernameMissing}
      showPasswordMissing={showPasswordMissing}
      showServerError={showServerError}
      showLoading={showLoading}
      data={data}
      passwordErrorMsg={passwordErrorMsg}
      twoFAErrorMsg={twoFAErrorMsg}
      openModalData={this.props.openModalData}
      onSubmit={this.onSubmit}
      onInputChange={this.onInputChange}
      onReCAPTCHAChange={this.onReCAPTCHAChange}
      recaptchaKey={recaptchaKey}
    />)
  }
}



// WEBPACK FOOTER //
// ./client/components/modals/user/signInContainer.js